import { render, staticRenderFns } from "./FinanceDetail.vue?vue&type=template&id=4f206260&"
import script from "./FinanceDetail.vue?vue&type=script&lang=js&"
export * from "./FinanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./FinanceDetail.vue?vue&type=style&index=0&id=4f206260&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports